import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectConstants} from '../../../project-constants';
import {RegionModel} from '../../../../models/RegionModel';
import {Subscription} from 'rxjs';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import * as toastr from 'toastr';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {SharedRegion} from '../../../../models/SharedRegion';

@Component({
  selector: 'app-new-region-anagraf',
  templateUrl: './new-region-anagraf.component.html',
  styleUrls: ['./new-region-anagraf.component.scss']
})
export class NewRegionAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  region: RegionModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;
  allInSettingsFilter: AllSettingsFilterModel;
  isShared: boolean;
  submitted = false;
  regionData: Array<RegionModel>;
  region_1: RegionModel;
  region_2: RegionModel;

  constructor(private route: ActivatedRoute, private router: Router,
              private regionService: RegionService,
              private loaderService: LoaderService) {
    super();

    this.region = new RegionModel();
    this.region_1 = new RegionModel();
    this.region_2 = new RegionModel();
    this.formBuilder = new FormBuilder();
    this.allInSettingsFilter = new AllSettingsFilterModel();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, [Validators.required]],
      description: [{value: '', disabled: false}, [Validators.required]],
      isShared: [{value: '', disabled: false}],
      region1: [{value: '', disabled: false}],
      region2: [{value: '', disabled: false}]
    });

    this.isShared = false;
  }

  ngOnInit() {

    this.regionService.getListInAllSettings(this.regionService.baseUrl, this.allInSettingsFilter)
      .subscribe((result: Array<RegionModel>) => {
        this.regionData = result.filter(elem => !elem.isShared);
        this.loaderService.display(false);
      }, error => {
        this.loaderService.display(false);
        toastr.error('Region Call Problem ecountered', 'Error');
      })

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.REGION_ANAGRF]);
  }

  save() {
    this.submitted = true;
    if (this.formValidator.valid) {
      event.preventDefault();
      this.region.cod = this.formValidator.value.cod;
      this.region.description = this.formValidator.value.description;
      this.region.isShared = this.isShared;
      this.region.sharedRegionObj = this.isShared ? new SharedRegion(this.region_1, this.region_2) : new SharedRegion();
      this.saveSubscribe = this.regionService.save(this.regionService.baseUrl + '/save', this.region).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Region Cod already exists', 'Warning');
          } else {
            toastr.success('Region was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.REGION_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy() {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

  checkIsShared() {
    if(this.isShared) {
      this.formValidator.controls['region1'].setValidators([Validators.required]);
      this.formValidator.controls['region2'].setValidators([Validators.required]);
    } else {
      this.formValidator.controls['region1'].clearValidators();
      this.formValidator.controls['region2'].clearValidators();
    }
    this.formValidator.get('region1').updateValueAndValidity();
    this.formValidator.get('region2').updateValueAndValidity();
  }

}
